import Helper from './Helper';
import NoHeader from './NoHeader';

class CategoryLoader {

  constructor() {
    this.categories = Array.prototype.slice.call(document.querySelectorAll('.category-page'));
    this.placeArticle = new Array();
    if (Array.isArray(this.categories) && this.categories.length) {
      this.readMoreLink = `
      <a class="ns-link" href="REPLACE">
        <span class="ns-link__icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="icon icon-read-more" viewBox="0 0 17 17">
            <defs>
              <filter id="icon-read-more-a">
                <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.650980 0 0 0 0 0.105882 0 0 0 0 0.152941 0 0 0 1.000000 0"/>
              </filter>
              <polygon id="icon-read-more-b" points="0 .018 16.981 .018 16.981 16.469 0 16.469"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
              <g>
                <mask id="icon-read-more-c" fill="#fff">
                  <use xlink:href="#icon-read-more-b"/>
                </mask>
                <path fill="currentColor" d="M8.49090095,16.46875 C13.1714597,16.46875 16.9814025,12.7798023 16.9814025,8.24357659 C16.9814025,3.70928532 13.1714597,0.0184031746 8.49090095,0.0184031746 C3.8083454,0.0184031746 0.000399365079,3.70928532 0.000399365079,8.24357659 C0.000399365079,12.7798023 3.8083454,16.46875 8.49090095,16.46875" mask="url(#icon-read-more-c)"/>
              </g>
              <polygon fill="#FEFEFE" points="13.304 8.146 9.098 12.042 7.31 12.042 10.874 8.763 3.696 8.763 3.696 7.519 10.874 7.519 7.31 4.25 9.098 4.25"/>
            </g>
          </svg>
        </span>
        <span class="ns-link__text">` + this.categories[0].dataset.readMore + `</span>
      </a>`;
      let i = 0;
      this.categories.forEach(category => {
        this.loadPage(category, i);
        i++;
      });
    }
  }

  loadPage(category, iteration) {
    const restUrl = category.dataset.restUrl;
    this.getData(restUrl).then((posts) => {
      for (let i = 0; i < posts.length; i++) {
        if (i == 0) {
          this.firstPost(posts[i], category, iteration);
        } else {
          this.placePost(posts[i], category, iteration);
        }
      }
      console.log(posts);
      this.showContainer(iteration);
      new NoHeader();
    });
  }

  getData(restUrl) {
    return fetch(restUrl, {
      headers: {
       'X-WP-Token': NSContext.token
      }})
      .then((response) => {
        return response.json();
      })
  }

  firstPost(post, category, iteration) {
    
    const article = document.createElement('article');
    article.innerHTML = post.content.replace('ns-img', 'ns-img loaded');
 
    const htmlContainer = `
    <div class="category-overview category-overview--` + iteration + `">
    <section class="category-overview__articles category-overview__articles--` + iteration + `" style="opacity: 0"><div id="js-append-here-` + iteration + `" class="category-overview__lines"></div></section>
    </div>
    `;

    article.classList.add('category');
    article.innerHTML += htmlContainer;
    Helper.loadImagesInDomElement(article);
    category.appendChild(article);
    this.placeArticle[iteration] = document.querySelector('#js-append-here-' + iteration);
  }

  placePost(post, category, iteration) {
    const hasLead = !post.categories.includes(parseInt(category.dataset.noLead));
    let hasImg = !post.categories.includes(parseInt(category.dataset.noImg));
    const hasLink = !post.categories.includes(parseInt(category.dataset.noLink));

    let img;
    let link = post.seo.url;
    let lead;

    if ( !link ) {
      link = "?p=" + post.id;
    }

    const element = document.createElement('div');
    element.innerHTML = post.content;
    if (hasImg) {
        const teaserImg = element.querySelector('.ns-img__teaser');
        let url;
        if(teaserImg && teaserImg !== undefined && !teaserImg.classList.contains('doc-image-empty')){
            url = teaserImg.dataset.src;
        } else{
          const bgImg = element.querySelector('.ns-img__bg-image');
          if(bgImg && bgImg != undefined){
            let style = bgImg.getAttribute('style');
            const a = style.split('background-image: url(');
            url = a[a.length - 1];
            url = url.slice(0, -1);
          }
        }
        if(url && url != undefined && !url.includes('data:image/svg+xml;charset=UTF')){
          img = '<a href="'+ link +'" class="overview-article__img-link"><div class="overview-article__img loaded" style=\'background-image: url("'+url+'")\'></div></a>';
        } else{
          img = false;
      }
    }

    if (hasLead) {
      lead = element.querySelector('.ns-lead');

      if(!lead){
        lead = element.querySelector('.ns-paragraph');
      }
    }

    let title = element.querySelector('.ns-title-h1');

    if (!title) {
      title = element.querySelector('.ns-title-h2');
      if (!title) {
        title = element.querySelector('.ns-title-h3');
      }
    }

    if(title){
      const article = document.createElement('div');
      article.classList.add('overview-article');
      //article.href = post.link;
      if (hasImg && img && img != undefined) {
        article.innerHTML += img;
      }
      article.innerHTML += '<h2 class="overview-article__title">' + title.innerHTML + '</h2>';
      if (hasLead && lead) {
        if(hasLink){
          article.innerHTML += '<p class="overview-article__lead">' + Helper.cutString(lead.innerHTML, 300), +'</p>';
        } else{
          article.innerHTML += '<p class="overview-article__lead">' + lead.innerHTML + '</p>';
        }
      }
      if(hasLink){
        article.innerHTML += this.readMoreLink.replace('REPLACE', link);
      }
      
      Helper.appendInDom(this.placeArticle[iteration], article);
    }
  }

  showContainer(i) {
    const container = document.querySelector('.category-overview__articles--' + i);

    /*
    if (Helper.isTablet()) {
      container.style.height = ((container.offsetHeight / 2) + 170) + 'px';
    }

     */
    container.style.opacity = 1;
  }

}

export default CategoryLoader;
